import React, { useState, useEffect, Fragment } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Collapse, Dialog, Grid, Grow, Icon, IconButton, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import useKYCDetailsModal from './useKYCDetailsModal';
import { blueGrey, green, grey } from '@material-ui/core/colors';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { format } from 'date-fns'
import LoadingContainer from '../../../../LoadingContainer';

const KYCDetailsModal = (props) => {

    const classes = useStyles()
    const {open, onClose} = props
    const {data,system, actions} = useKYCDetailsModal({open})

    const {selected} = data

    return ( 
        <Dialog open={open} maxWidth={data.kyc && data.kyc.length ? 'md' : 'sm'} fullWidth classes={{ paper: classes.paper }} className={classes.root}
        TransitionComponent={Transition} onClose={onClose} scroll='body'>
            <div className={classes.root}>
                <IconButton className={classes.close_button} onClick={onClose} ><Icon>close</Icon></IconButton>
                <div>
                    <Typography variant='h6'>KYC Details</Typography>
                    <div style={{marginTop:16}}>
                        <LoadingContainer loading={system.loading}>
                            {data.kyc && data.kyc.length ? <Table stickyHeader>
                                <TableHead>
                                    <TableRow>
                                        {header.map(item => {
                                            return(
                                                <TableCell key={`th-kyc-${item.id}`} className={classes.cell_header}>{item.label}</TableCell>
                                            )
                                        })}
                                    </TableRow>    
                                </TableHead>
                                <TableBody>
                                    {data.kyc.map(item => {

                                        const _date = new Date(item?.dateTran)
                                        const _date_date = format(_date, 'MM/dd/yy')
                                        const _date_time = format(_date, 'HH:mm:ss')

                                        let open = false
                                        if(selected){
                                            open = selected.idTran === item?.idTran
                                        }
                                        //console.log(open, selected)
                                        return(
                                            <Fragment key={`tr-${item?.idTran}`}>
                                                <TableRow >
                                                    <TableCell className={classes.cell_body}  padding='checkbox'>
                                                        <IconButton aria-label="expand row" size="small" onClick={() => actions.onSelectedItem(item)}>
                                                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell className={classes.cell_body}  padding='checkbox'>
                                                        <Typography>{item?.idTran}</Typography>
                                                    </TableCell>
                                                    <TableCell className={classes.cell_body} >
                                                        <Grid container direction='column'>
                                                            <Grid item><Typography>{_date_date}</Typography></Grid>
                                                            <Grid item><Typography>{_date_time}</Typography></Grid>
                                                        </Grid>
                                                    </TableCell>
                                                    <TableCell className={classes.cell_body} >
                                                        <Typography variant='body2' noWrap>{item?.providerData?.referenceId}</Typography>
                                                    </TableCell>
                                                    <TableCell className={classes.cell_body} >
                                                        <Typography variant='body2' noWrap>{item?.providerData?.modelName}</Typography>
                                                    </TableCell>
                                                    <TableCell className={classes.cell_body} >
                                                        <Typography variant='body2' noWrap>{item?.providerData?.modelVersion}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                        <Collapse in={open} timeout="auto" unmountOnExit>
                                                            <div style={{padding:16}}>
                                                                {item?.providerData?.reasonCodes?.sections.map((el, key) => {
                                                                    return(
                                                                        <Accordion key={`accordion-${key}`}>
                                                                            <AccordionSummary
                                                                                expandIcon={<Icon color="primary">add</Icon>}
                                                                                className={classes.accordion_summary}
                                                                                classes={{root:classes.accordion_summary_root}}
                                                                            >
                                                                                <Typography variant='body2'>
                                                                                    <strong>{`${el?.name}`}</strong>  {`(${el?.codes.length} elements)`}
                                                                                </Typography>
                                                                            </AccordionSummary>
                                                                            <AccordionDetails>
                                                                                <Grid container spacing={1}>
                                                                                    {el?.codes.map((dat, ids)=>{
                                                                                        return(
                                                                                            <Grid item xs={12} key={`code-${key}-${ids}`}>
                                                                                                <div style={{borderTop:`1px solid ${grey[300]}`, padding:'8px 0px'}}>
                                                                                                    <Typography variant='body2'><strong>{dat?.code}</strong> - {dat?.description}</Typography>
                                                                                                </div>
                                                                                            </Grid>
                                                                                        )
                                                                                    })}
                                                                                </Grid>
                                                                            </AccordionDetails>
                                                                        </Accordion>
                                                                    )
                                                                })}
                                                            </div>
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            </Fragment>
                                        )
                                    })}
                                </TableBody>
                            </Table> : (
                                <div>
                                    <Grid container alignItems='center' direction='column'>
                                        <Grid item>
                                            <div className={classes.icon_container}>
                                                <Icon className={classes.checkIcon}>
                                                    search
                                                </Icon>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <Typography style={{maxWidth:250}} align='center'>We've not found any register related to this account</Typography>
                                        </Grid>
                                    </Grid>
                                </div>
                            )}
                        </LoadingContainer>
                        
                    </div>

                </div>
            </div>
        </Dialog>
     );
}

const useStyles = makeStyles(theme => ({
    paper:{
        borderRadius:32, 
        padding:theme.spacing(5),
        position:'relative',
        [theme.breakpoints.down('sm')]:{
            padding:theme.spacing(3),
            margin:8
        },  
    },
    root:{
    },
    icon:{
        //color:'white',
        borderRadius:'50%',
        fontSize:54,
        padding:8
    },
    close_button:{
        position:'absolute', right:16, top:16
    },
    table:{
        maxHeight:500,
    },
    table_wrapper:{
        minWidth:800,
        maxHeight:500
    },
    header:{
        display:'flex',
        wrap:'no-wrap'
    },
    cell_header:{
        background:theme.palette.primary.dark,
        color:'white',
        //background:'white',
        //fontWeight:700,
        fontSize:16,
        boxSizing:'border-box',
        padding:4,
        textAlign:'center'
    },
    cell_body:{
        //width:140,
        fontWeight:400,
        fontSize:16,
        boxSizing:'border-box',
        //padding:4,
        color:blueGrey[700],
        fontWeight:500,

    },
    cell_text_header:{
        color:'white',
        fontWeight:700,
        paddingLeft:8
    },
    icon_container:{
        width:90,
        height:90,
        border:`2px solid ${blueGrey[200]}`,
        background:blueGrey[50],
        borderRadius:'50%',
        position:'relative',
        position:'relative',
        marginTop:40,
        marginBottom:40,
    },
    checkIcon:{
        position:'absolute',
        top:'50%', left:'50%',
        transform:'translate(-50%, -50%)',
        fontSize:48,
        color:blueGrey[500]
    }
}))
 
export default KYCDetailsModal;

const Transition = React.forwardRef(function Transitios(props, ref) {return <Grow ref={ref} {...props} timeout={500} />;});

const header = [
    {id:-1, label:''},
    {id:1, label:'ID'},
    {id:2, label:'Date/Time'},
    {id:3, label:'Reference ID'},
    {id:4, label:'Model name'},
    {id:5, label:'Version'},
]